import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Stack,
  Typography,
  Chip,
  TextField,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
import { useSnackbar } from 'notistack';

const Dictionary = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [chipData, setChipData] = useState([]);
  const [textValue, setTextValue] = useState();

  const handleSubmit = async () => {
    if (!textValue) {
      alert('Please enter text.');
      return;
    }
    try {
      const data = [...chipData, textValue];
      const response = await axios.post('/ai/dictionary-words', {
        words: data,
      });
      if (response.status === 200) {
        setTextValue(null);
        handleFetch();
      }
    } catch (error) {
      enqueueSnackbar(error?.data?.message, {
        variant: 'error',
      });
    }
  };
  const handleFetch = async () => {
    const response = await axios.get('/ai/dictionary-words');
    if (response.status === 200) {
      setChipData(response?.data?.data?.result?.dictionary_words);
    }
  };

  const handleDelete = async (index) => {
    let data = chipData.filter((_, i) => i !== index);
    console.log({ data });
    try {
      const response = await axios.post('/ai/dictionary-words', {
        words: data,
      });
      if (response.status === 200) {
        handleFetch();
      }
    } catch (error) {}
  };

  useEffect(() => {
    handleFetch();
  }, []);

  return (
    <center>
      <Stack
        justifyContent="center"
        direction={{ xs: 'column', sm: 'row' }}
        sx={{
          width: '100%',
          maxWidth: '900px',
          background: '#D3D04F',
          padding: '30px 20px',
          borderRadius: '15px 15px 0 0',
        }}
      >
        <Typography
          variant={'h1'}
          mb={0}
          sx={{ fontSize: '32px', fontWeight: '500' }}
        >
          Dictionary
        </Typography>
      </Stack>
      <Card
        sx={{
          width: '100%',
          maxWidth: '900px',
          textAlign: 'center',
          padding: '0 20px ',
          borderRadius: '0 0 15px 15px',
        }}
      >
        <CardContent>
          <Stack style={{ minHeight: '200px' }}>
            <Stack
              direction="row"
              style={{ flexWrap: 'wrap' }}
              // spacing={2}
              mb={2}
            >
              {chipData.map((chip, index) => (
                <Chip
                  key={index}
                  label={chip}
                  variant="outlined"
                  onDelete={() => handleDelete(index)}
                  sx={{ margin: '0 10px 10px 0' }}
                />
              ))}
            </Stack>
          </Stack>
          <Stack direction="row" spacing={2} mb={2}>
            <TextField
              id="outlined-basic"
              label="Enter Text..."
              variant="outlined"
              size="small"
              fullWidth
              value={textValue || ''}
              onChange={(e) => setTextValue(e?.target?.value?.trim())}
            />
            <LoadingButton
              onClick={handleSubmit}
              type="submit"
              variant="contained"
            >
              Add
            </LoadingButton>
          </Stack>
        </CardContent>
      </Card>
    </center>
  );
};

export default Dictionary;
